import { render } from "./BoxPlot.vue?vue&type=template&id=0482fcb4&scoped=true"
import script from "./BoxPlot.vue?vue&type=script&lang=js"
export * from "./BoxPlot.vue?vue&type=script&lang=js"

import "./BoxPlot.vue?vue&type=style&index=0&id=0482fcb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0482fcb4"]])

export default __exports__